<template>
  <div class="container">
    <div class="row align-items-sm-center justify-content-between mt-34">
      <div class="slopePage__title">
        <b>Крепежный элемент</b>
      </div>
      <div class="toggler__box unprint" v-if="count > 1 && fasteners.length !== 0">
        <span class="showMore__text">
          Показать к-во на аналогичных участках ({{ this.count }})
        </span>
        <div class="fixtureCalculation__toggle">
          <div class="wrapper">
            <span class="checkbox-toggler">
              <span class="checkbox-track"></span>
              <input type="checkbox"
                     v-model="isShowMore"
                     @click="isShowMore = !isShowMore">
                <span class="toggler"></span>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="fasteners.length === 0">
      <div class="slopePage__info">
        <img src="@/assets/img/info-result.svg" alt="info" class="slopePage__info-img">
        <div class="slopePage__info-text" >
          Для данного участка расчет крепежей отключен
        </div>
      </div>
    </div>
    <div class="row" v-if="fasteners.length !== 0">
      <div class="detailsPage__fastener-head">
        <div class="item">
          <div class="item__title">
            Наименование
          </div>
          <div class="item__title">
            <span>К-во</span>
            <span class="item__title-additional" v-if="isShowMore && count > 1">
              {{ count }} уч.
            </span>
          </div>
        </div>
        <div class="item">
          <div class="item__title">
            Наименование
          </div>
          <div class="item__title">
            <span>К-во</span>
            <span class="item__title-additional" v-if="isShowMore && count > 1">
              {{ count }} уч.
            </span>
          </div>
        </div>
      </div>
      <div class="detailsPage__fastener-body">
        <div class="item" v-for="item in filteredFasteners" :key="item.id">
          <div class="item__img">
            <img :src="item.src" :alt="item.name">
          </div>
          <div class="item__name">
            {{ item.name }}
          </div>
          <div class="item__count">
            <span>{{ item.count }} шт.</span>
            <span class="item__count-additional" v-if="isShowMore && count > 1">
              {{ item.totalCount }} шт.
            </span>
          </div>
        </div>
      </div>
      <div class="detailsPage__fastener-footer"
           v-if="fasteners.length > 18"
           @click="isShowRemaining = !isShowRemaining"
           :class="{ active: isShowRemaining }">
          <div v-if="!isShowRemaining" class="detailsPage__fastener-footer-count">
            Показать все: {{ fasteners.length }}
          </div>
          <div v-else class="detailsPage__fastener-footer-count">Скрыть</div>
          <div class="detailsPage__fastener-footer-arrow">
            <img src="@/assets/img/select-tick-red.svg" alt="">
          </div>
        </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    count: Number,
    isFastenersNeed: Boolean,
  },
  data() {
    return {
      isShowMore: true,
      isShowRemaining: false,
    };
  },
  components: {
  },
  methods: {
  },
  watch: {
  },
  mounted() {
  },
  computed: {
    sortedFasteners() {
      return this.fasteners.sort((a, b) => {
        const nameA = a.name.toUpperCase();
        const nameB = b.name.toUpperCase();
        let comparison = 0;
        if (nameA > nameB) {
          comparison = -1;
        } else if (nameA < nameB) {
          comparison = 1;
        }
        return comparison;
      });
    },
    filteredFasteners() {
      return this.isShowRemaining ? this.fasteners : this.fasteners.slice(0, 18);
      // return this.isShowRemaining ? this.sortedFasteners : this.sortedFasteners.slice(0, 18);
    },
    slopeId() {
      return (this.$route.params.id) ? this.$route.params.id : 0;
    },
    result() {
      return this.$store.getters.getResult;
    },
    fasteners() {
      return this.result.sections[this.$route.params.id].fasteners;
    },
  },
};

</script>

<style lang="sass" scoped>
.detailsPage
  .mt-34
    margin-top: rem(34)
  .slopePage
    &__title
      +media((font-size: (320: rem(18), 992: rem(24))))
      +media((line-height: (320: rem(26), 992: rem(29))))
      +media((padding: (320: rem(25) rem(24) rem(23), 992: rem(36) 0)))
  .toggler__box
    display: flex
    flex-direction: row
    align-items: center
    +media((padding-right: (320: rem(27), 768: rem(3))))
    +media((padding-bottom: (320: rem(28), 637: rem(0))))
    .showMore
      &__text
        font-style: normal
        font-weight: 500
        padding-right: rem(20)
        text-align: left
        +media((padding-left: (320: rem(24), 992: 0)))
        +media((font-size: (320: rem(12), 992: rem(14))))
        +media((line-height: (320: rem(20), 992: rem(22))))
    .checkbox-toggler
      .checkbox-track
        box-shadow: inset 0 rem(2) rem(4) rgba(153, 153, 153, 0.5)
  &__fastener
    &-head
      display: grid
      +media((grid-template-columns: (320: 1fr, 768: repeat(2, 1fr))))
      @extend .common__result-header
      .item
        display: grid
        +media((padding-left: (320: rem(24), 768: 0)))
        +media((grid-template-columns: (320: 3fr 6fr 3fr, 768: 3fr 5fr 4fr)))
        &:last-of-type
          +media((display: (320: none, 768: grid)))
        &__title
          min-height: rem(60)
          display: flex
          flex-direction: row
          align-items: center
          @extend .common__title-result
          text-align: left
          &:first-of-type
            grid-column-start: 2
          &:last-of-type
            span
              +media((padding-left: (320: rem(24), 768: 0)))
          span
            min-width: rem(80)
          &-additional
            color: #999999
            +media((display: (320: none, 768: flex)))
    &-body
      width: 100%
      display: grid
      +media((grid-template-columns: (320: 1fr, 768: repeat(2, 1fr))))
      .item
        background: #fff
        border: rem(1) solid #ECECEC
        display: grid
        padding: rem(2) 0
        +media((padding-left: (320: rem(24), 768: 0)))
        +media((grid-template-columns: (320: 3fr 6fr 3fr, 768: 3fr 5fr 4fr)))
        &__img
          display: flex
          flex-direction: row
          align-items: center
          +media((justify-content: (320: flex-start, 768: center)))
          img
            max-width: rem(69)
        &__name, &__count
          font-style: normal
          font-weight: 500
          line-height: rem(30)
          text-align: left
          align-items: center
          display: flex
        &__name
          font-size: rem(14)
        &__count
          font-size: rem(16)
          display: flex
          +media((align-items: (320: flex-start, 768: center)))
          +media((flex-direction: (320: column, 768: row)))
          span
            min-width: rem(80)
            +media((padding-left: (320: rem(24), 768: 0)))
          &-additional
            color: #999999
    &-footer
      display: flex
      flex-direction: row
      align-items: center
      justify-content: space-between
      cursor: pointer
      @extend .common__result-footer
      &-count
        @extend .common__result-footer--count
      &-arrow
        @extend .common__result-footer--arrow
      &.active
        .detailsPage__fastener-footer-arrow
          img
            transform: rotate(180deg)
</style>
